import { Button, Col, Form, Input, Modal, notification, Row } from 'antd';
import React, { useCallback, useEffect } from 'react';

import { ShipType } from '../../models/ShipType';

interface IProps {
  selectedShipType?: ShipType;
  submitting?: boolean;
  error?: Error | null;
  onSubmit: (shipType: ShipType) => void;
  onClose: () => void;
}

const ModeDialog: React.FC<IProps> = ({
  error,
  onClose,
  onSubmit,
  selectedShipType,
  submitting,
}) => {
  const [form] = Form.useForm();

  const closeModal = useCallback(() => {
    form.resetFields();
    onClose();
  }, [form, onClose]);

  const submitForm = useCallback(
    (shipType: ShipType) => {
      if (selectedShipType) {
        // Add New Mode
        shipType.id = selectedShipType.id;
      }
      onSubmit(shipType);
    },
    [onSubmit, selectedShipType]
  );

  useEffect(() => {
    if (selectedShipType) {
      form.setFieldsValue(selectedShipType);
    }
  }, [form, selectedShipType]);

  useEffect(() => {
    if (error) {
      notification.error({
        description: error.message,
        message: error.name,
      });
    }
  }, [error]);

  return (
    <Modal
      centered
      visible
      footer={null}
      maskClosable={false}
      title={!selectedShipType ? 'Add Ship Type' : 'Edit Ship Type'}
      width={400}
      onCancel={closeModal}
    >
      <Form form={form} layout="vertical" onFinish={submitForm}>
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item
              label="Ship Type"
              name="name"
              rules={[
                { message: 'Ship Type name is required!', required: true },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Notes" name="notes">
              <Input.TextArea rows={5} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item>
              <Button className="modal-close-btn" onClick={closeModal}>
                Cancel
              </Button>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item>
              <Button
                className="modal-save-btn"
                htmlType="submit"
                loading={submitting}
                type="primary"
              >
                SAVE
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ModeDialog;
